module.exports = __webpack_public_path__ + "img/Okta-logo.79685ff5.png";